import { styled } from '@mui/material'
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar'
import { drawerWidth } from '~/components/Layout'

interface AppBarProps extends MuiAppBarProps {
  open?: boolean
}

export const StyleAppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme: innerTheme, open }) => ({
  zIndex: 10,
  width: `calc(100% - ${innerTheme.spacing(8)})`,
  [innerTheme.breakpoints.down('md')]: {
    width: '100%'
  },
  transition: innerTheme.transitions.create(['width', 'margin'], {
    easing: innerTheme.transitions.easing.sharp,
    duration: innerTheme.transitions.duration.leavingScreen,
  }),
  ...open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: innerTheme.transitions.create(['width', 'margin'], {
      easing: innerTheme.transitions.easing.sharp,
      duration: innerTheme.transitions.duration.enteringScreen,
    }),
  },
}))
